import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import ButtonText from '@segment/matcha/components/ButtonText'

import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'
import * as CopyText from '@segment/matcha/recipes/CopyText'

const copy = {
  heading: `Plans scale with your growth`,
}

const button = {
  text: `Which plan is right for you?`,
  url: `#which-plan-is-right-for-you`,
}

const Hero: FC<PropsWithChildren> = () => {
  return (
    <Wrapper>
      <StyledHeroBase variant="centered">
        <HeroRecipe.Copy>
          <CopyText.Heading variant="h1" tag="h1">
            {copy.heading}
          </CopyText.Heading>
          <HeroRecipe.Contents>
            <ButtonText href={button.url}>{button.text}</ButtonText>
          </HeroRecipe.Contents>
        </HeroRecipe.Copy>
      </StyledHeroBase>
    </Wrapper>
  )
}

const Wrapper = styled.header`
  background-color: ${({ theme }) => theme.palette.twilio.gray[10]};
`
const StyledHeroBase = styled(HeroBase)`
  ${HeroRecipe.Wrapper} {
    padding-bottom: 0px;
    gap: 0;
  }
`

export default Hero
